import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-scroll";
import { slide as Menu } from 'react-burger-menu';
import DeloLogo from "../../img/logo-delo.webp";
import TopSto from "../../img/top-100.webp";

import LogoBWS from "../../img/bws-logo.svg";

function Header() {
    const buttonClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'button_click',
        });
    };

    const programClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'program_click',
        });
    };

    const speacersClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'speacers_click',
        });
    };

    const aboutClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'about_click',
        });
    };

    const formatsClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formats_click',
        });
    };

    const [menuState, setMenuState] = useState();
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const isMenuOpen = (state) => state.isOpen;

    useEffect(() => {
        isMenuOpen === false ? setMenuState(true) : setMenuState(false)
    });

    const toggleMenu = () => setMenuState(true);

    return (
        <header className={offset>=10 ? 'fixed top-0 left-0 py-2 w-full z-[100] bg-white border-b border-black' : 
            'fixed z-[100] top-0 left-0 w-full py-2 border-b border-black lg:py-3'} style={{ transition: '0.5s' }}>

            <div className="container relative max-w-screen-xl mx-auto flex justify-between items-center px-3">

                <div className="sm:w-28 w-20">
                    <a href="/" className={offset>=10 ? 'block sm:w-20 w-16' : 'hidden'} style={{ transition: '0.5s' }}>
                        <img src={LogoBWS} alt="Logo BWS" className="w-full"/>
                    </a>
                    <div className={offset>=10 ? 'hidden' : 'flex flex-wrap items-center gap-4'} style={{ transition: '0.5s' }}>
                        <a href="https://delo.ua/" class="sm:w-12 w-8" target="_blank">
                            <img src={DeloLogo} alt="Logo Delo" className="w-full"/>
                        </a>
                        <a href="https://delo.ua/top100/" class="sm:w-12 w-8" target="_blank">
                            <img src={TopSto} alt="Top 100" className="w-full"/>
                        </a>
                    </div>
                </div>

                <nav className="hidden lg:block">
                    <ul className="flex items-center gap-14">
                        <li>
                            <Link to="about" smooth={true} offset={-70} duration={500} onClick={aboutClick}>
                                Про захід
                            </Link>
                        </li>
                        <li>
                            <Link to="speacers" smooth={true} offset={-70} duration={500} onClick={speacersClick}>
                                Спікери
                            </Link>
                        </li>
                        <li>
                            <Link to="programm" smooth={true} offset={-70} duration={500}>
                                Програма
                            </Link>
                        </li>
                        <li>
                            <Link to="formats" smooth={true} offset={-70} duration={500} onClick={formatsClick}>
                                Формат участі
                            </Link>
                        </li>
                    </ul>
                </nav>

                <Link to="formats" spy={true} smooth={true} offset={-70} duration={500} onClick={buttonClick}
                    className="bg-[#ece66a] font-bold uppercase py-1 px-2 ml-auto mr-8 hover:bg-[#F5D858] transition-all ease-in-out duration-300
                        md:py-2 md:px-5 md:text-[18px] md:leading-[1.1] lg:text-[22px] lg:py-3 lg:px-10 lg:ml-0 lg:mr-0">
                    Взяти участь
                </Link>

                <div className="block lg:hidden" style={{ transition: '0.5s' }}>
                    <Menu onStateChange={isMenuOpen} isOpen={menuState} pageWrapId={"page-wrap"}>
                        <nav>
                            <ul className="text-black">
                                <li className="mb-3">
                                    <Link to="about" onClick={() => { toggleMenu(); aboutClick(); }} smooth={true} offset={-70} duration={500}>
                                        Про захід
                                    </Link>
                                </li>
                                <li className="mb-3">
                                    <Link to="speacers" onClick={() => { toggleMenu(); speacersClick(); }} smooth={true} offset={-70} duration={500}>
                                        Спікери
                                    </Link>
                                </li>
                                <li className="mb-3">
                                    <Link to="programm" onClick={toggleMenu} smooth={true} offset={-70} duration={500}>
                                        Програма
                                    </Link>
                                </li>
                                <li className="mb-3">
                                    <Link to="formats" onClick={() => { toggleMenu(); formatsClick(); }} smooth={true} offset={-70} duration={500}>
                                        Формат участі
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </Menu>
                </div>

            </div>

        </header>
    );

}

export default Header;